/**
 * Mounts the support widget on the CONSUMER surfaces only.
 *
 * Staff surfaces (/admin/*, /platform/*) have the agent console instead — a
 * customer-facing help chat there would be noise, and the widget's anonymous
 * token custody has no business on a staff screen.
 *
 * Lazy so the widget never sits in the consumer entry chunk.
 */
import { Suspense, lazy } from "react";
import { useLocation } from "react-router-dom";

const SupportWidget = lazy(() => import("./SupportWidget"));

/**
 * `/create/*` is excluded too. The funnel is single-task: a floating widget
 * there competes with the one CTA that screen exists for, and every error or
 * refusal screen in the funnel already carries its own route out. Help belongs
 * where people who are stuck actually are — the landing page before they start,
 * and the account surfaces afterwards.
 */
const EXCLUDED = ["/admin", "/platform", "/support/thread", "/login", "/create"];

export default function SupportWidgetMount() {
  const { pathname } = useLocation();
  if (EXCLUDED.some((p) => pathname === p || pathname.startsWith(`${p}/`))) return null;
  return (
    <Suspense fallback={null}>
      <SupportWidget />
    </Suspense>
  );
}
